import type { TagName } from '#schemas/tag/name.ts';

const LIMIT = 50;

export function matchTags(tags: TagName[], search: string) {
  return tags
    .filter((tag) => {
      const [key, value] = tag.split(':');
      return Boolean(key?.startsWith(search)) || Boolean(value?.startsWith(search)) || tag.startsWith(search);
    })
    .slice(0, LIMIT);
}
